import React, { useState, useEffect } from "react";
import { injectIntl } from "react-intl";
import "./modalStyle.scss";
import "../../../components/PatientPreviewForm/style.scss";
import CancelIcon from '@material-ui/icons/Cancel';
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import ConfirmDialog from "../../../components/ConfirmDialog/ConfirmDialog";
import DateFnsUtils from '@date-io/date-fns';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import Scheduler from "./Scheduler";
import { addAppointmentRequest } from "../../../store/appointments/actions";

const AddAppointmentForm = ({ intl: { messages }, show, close, userId }) => {
     const lang = localStorage.getItem("lang") || "en";
     const user = useSelector((state) => state.auth?.user?.data);
     const dispatch = useDispatch();
     const [feedBack, setFeedBack] = useState(null);
     const [showConfirmation, setShowConfirmation] = useState(false);
     const [selectedAppsDate, setSelectedAppsDate] = useState(moment().format('YYYY-MM-DD'));
     const { addedApp } = useSelector((state) => state.appointments);
     const appTypes = [
        {id: 2, name: messages.patients.form.video_call},
        {id: 4, name: messages.patients.form.at_office},
        {id: 3, name: messages.patients.form.audio_call},
        {id: 1, name: messages.patients.form.textual_app},
    ]
    const appStatus = [
        {id: 1, name: messages.patients.form.first_app},
        {id: 2, name: messages.patients.form.inquiry_app},
        {id: 3, name: messages.patients.form.explantation_app},
    ]
    const [appointment, setAppointment] = useState({
        patient_id: '',
        user_id: 0,
        start_date: '',
        type: 0,
        purpose: 0,
        time: '',
    });

    const clear = () => {
        setAppointment({
            patient_id: '',
            user_id: 0,
            start_date: '',
            type: 0,
            purpose: 0,
            time: '',
        });
        setSelectedAppsDate(moment().format('YYYY-MM-DD'));
    }

    const validation = () => {
        let isValid = true;
        if (appointment?.purpose === 0 ) {
            document.getElementById('appStatus').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedBack(messages.patients.form.app_status_feedback);
        }
        if (appointment?.type === 0) {
            document.getElementById('appTypes').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedBack(messages.patients.form.app_type_feedback);
        }
        if (!appointment?.time) {
            isValid = false;
            setFeedBack(messages.patients.form.time_feedback);
        }
        if (appointment?.user_id === 0) {
            document.getElementById('specialist').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedBack(messages.patients.form.specialist_feedback);
        }
        return isValid;
    }
    //Clear and close
    useEffect(() => {
        if (addedApp) {
            clear();
            close();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [addedApp]);

    return (
        <div className={`app-modal_container ${show && " show"} ${lang === 'ar' && 'rtlPosition'}`}>
            <div className="app-modal_container_content">
                    <CancelIcon onClick={close} className="app-modal_container_content_close" />
                <div className="app-modal_container_content_header">
                    <h4>{messages.patients.appointments.user_appointments}</h4>
                </div>
                <div className="app-modal_container_content_body">
                    <form>
                        <div className="row">
                            <div className="col-md-8">
                                <Scheduler userId={userId} currentDate={selectedAppsDate} />
                            </div>
                            <div className="col-md-4">
                                <MuiPickersUtilsProvider utils={DateFnsUtils} local={lang === 'ar' ? 'ar-SA' : 'en-US'}>
                                    <DatePicker
                                        autoOk
                                        disableToolbar={true}
                                        disablePast={true}
                                        orientation="landscape"
                                        variant="static"
                                        openTo="date"
                                        value={selectedAppsDate}
                                        onChange={(date) => setSelectedAppsDate(moment(date).format('YYYY-MM-DD'))}
                                    />
                                </MuiPickersUtilsProvider>
                                <div style={{ marginTop: '20px' }}>
                                    <label htmlFor="specialist" >{messages.patients.form.specialist}</label>
                                    <select name="specialist" id="specialist" disabled={true}
                                            style={{ width: '100%' }}
                                            value={userId}
                                            >
                                        <option value={userId}>{user.name}</option>
                                    </select>
                                </div>
                                
                                <div>
                                    <label htmlFor="appTypes" >{messages.patients.form.app_type}</label>
                                    <select name="appTypes" id="appTypes" disabled={true}
                                            style={{ width: '100%' }}
                                            value={appointment.type}
                                            onChange={e => {
                                                document.getElementById('appTypes').style.borderColor = '#eee';
                                                setFeedBack('');
                                                setAppointment({ ...appointment, type: e.target.value })
                                                }}
                                            >
                                        <option value={0}>{messages.patients.form.app_type_placeholder}</option>
                                        {appTypes?.map(type => <option key={type.id} value={type.id}>{type.name}</option>)}
                                    </select>
                                </div>
                                <div>
                                    <label htmlFor="appStatus" >{messages.patients.form.app_status}</label>
                                    <select name="appStatus" id="appStatus" disabled={true}
                                            style={{ width: '100%' }}
                                            value={appointment.purpose}
                                            onChange={e => {
                                                document.getElementById('appStatus').style.borderColor = '#eee';
                                                setFeedBack('');
                                                    setAppointment({ ...appointment, purpose: e.target.value })
                                                }}
                                            >
                                        <option value={0}>{messages.patients.form.app_status_placeholder}</option>
                                        {appStatus?.map(status => <option key={status.id} value={status.id} 
                                                               // disabled={(status.id === 1 && appointment.purpose === 2) || (status.id === 1 && appointment.purpose === 3) || (appointment.purpose === 1 && status.id !== 1)}
                                                                >{status.name}</option>)}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="actions">
                                <button className="cancel" 
                                    onClick={(e) => {
                                        e.preventDefault();
                                        close();
                                        }}>
                                        {messages.patients.form.btn_cancel}                           
                                </button>
                                <button disabled={true} onClick={(e) =>  {
                                    e.preventDefault();
                                    if (validation()) {
                                        dispatch(addAppointmentRequest({ ...appointment, start_date: `${selectedAppsDate} ${appointment.time}` }));
                                    }
                                    }} >
                                    {messages.patients.form.btn_save}
                                </button>
                        </div>
                        <p id="feedback"><span style={{ background: '#FFF' }}>{feedBack}</span></p>
                    </form>   
                </div>
            </div>
            <ConfirmDialog show={showConfirmation} 
                     onCancel={() => setShowConfirmation(false)}
                     onConfirm={() => {
                        setShowConfirmation(false);
                        clear();
                        close();
                     }}
                     content={messages.warningMsgs.warning_close_window}
                     cancelBtn={messages.warningMsgs.cancel}
                     confirmBtn={messages.warningMsgs.confirm} />
        </div>
    );
}
export default injectIntl(AddAppointmentForm);
